import React from 'react';
import Navbar from '../commonComponents/Navbar';
import HeroSection from '../commonComponents/HeroSection';
import StatsSection from '../commonComponents/StatsSection';
import AssetTable from '../commonComponents/AssetTable';
import DifferenceSection from '../commonComponents/DifferenceSection';
import FaqSection from '../commonComponents/FaqSection';
import Footer from '../commonComponents/Footer';

const Home = () => {
  return (
    <div className="page-enter">
      <Navbar />
      <HeroSection />
      <StatsSection />
      <AssetTable />
      <DifferenceSection />
      <FaqSection />
      <Footer />
    </div>
  );
};

export default Home;
